module.exports = __webpack_public_path__ + "img/20200514_155137.016ec2b4.jpg";